

























































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Promocao } from '@/models'
import { FindPromocaoUseCase } from '@/usecases/venda/FindPromocaoUseCase'
import { dateToPtBrFormat } from '@/shareds/date/date-utils'
import { PromocaoModule } from '@/store/vuex/venda/PromocaoStore'

@Component({})
export default class DialogoDePromocoes extends Vue {
	@Prop({ required: true}) promocoesDisponiveisParaUso!: Promocao[]

	mostraDialogo = false
	carregando = false
	abaAtiva = 0
	findPromocaoUseCase = new FindPromocaoUseCase()
	dateToPtBrFormat = dateToPtBrFormat

	PromocaoModule = PromocaoModule

	get promocoesDesconto() {
		return this.promocoesDisponiveisParaUso.filter(p => p.tipoDePromocao === 'Desconto')
	}

	get promocoesBrinde() {
		return this.promocoesDisponiveisParaUso.filter(p => p.tipoDePromocao === 'Brinde')
	}

	get promocoesOutras() {
		return this.promocoesDisponiveisParaUso.filter(p => p.tipoDePromocao !== 'Desconto' && p.tipoDePromocao !== 'Brinde')
	}

	mostrar() {
		this.mostraDialogo = true
	}

	fecharDialogo() {
		this.mostraDialogo = false
	}

	selecionarPromocao(promocao: Promocao) {
		this.$emit('aplicar-promocao', promocao)
	}

	formatarData(data: string): string {
		return this.dateToPtBrFormat(data)
	}

	metodosDePagamentoDaPromocao(promocao: Promocao): string[] {
		if (!promocao.regrasDeAplicacaoPromocao) return [];
		return promocao.regrasDeAplicacaoPromocao
			.filter(regra => regra.tipoDeGatilho === 'Método de pagamento')
			.map(regra => regra.valor)
			.filter((valor, idx, arr) => valor && arr.indexOf(valor) === idx);
	}
}
